import { makeStore } from '@shared/app/model/store/store';
import moment from 'moment';
import Vue from 'vue';
import { EventBus } from './app/connector/EventBus';
import Realtime from './app/connector/Realtime';
import { RealtimeWithDataService } from './app/connector/data-service/RealtimeWithDataService';
import { AppConfiguration2 } from './app/model/AppConfiguration2';
import AppConstants from './app/model/AppConstants';
import AppComponents from './app/ui';
import DisengageWrapper from './app/ui/DisengageWrapper.vue';
import LayoutComponents from './layout/ui';

/* !! Application bootstrap !! */

export default async (appConfiguration: AppConfiguration2) => {
  appConfiguration.components = {
    ...appConfiguration.components,
    ...AppComponents,
    ...LayoutComponents,
  };

  moment.locale('fr');

  // Enregistrement des composants
  Object.keys(appConfiguration.components).forEach((name) => {
    Vue.component(name, appConfiguration.components[name]);
  });

  const store = await makeStore(appConfiguration.page);

  // Debug fn : get all state from console
  window.getState = () => store.state;

  // Realtime instance
  const realtime = Realtime.getInstance(store);
  Vue.prototype.realtime = realtime;

  const app = new Vue({
    store,
    data: {},
    render: (h) => h(DisengageWrapper),
  });

  app.$mount('#app').$nextTick(() => {
    // Client socket.io pour le temps-réel (inject. des maj)
    if (
      process.env.NODE_ENV === AppConstants.ENV.PRODUCTION ||
      window.location.search.includes('realtime=1')
    ) {
      // Doit on utiliser le nouveau service de données ?
      if (process.env.VUE_APP_DATASERVICE_URLS) new RealtimeWithDataService(store).connect();
      else realtime.init();
    }
    // eslint-disable-next-line no-console
    else console.info('Temps-réel désactivé hors production');

    // Utile au redim. de certains éléments
    window.addEventListener('resize', () => {
      EventBus.$emit(AppConstants.BACKDOOR_EVENT_NAME);
    });
  });

  return app;
};
